import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
  query csvReports($teamIds: [Int!], $overseerId: Int!) {
    getLatestCsvReports(teamIds: $teamIds, overseerId: $overseerId) {
      teamId
      reports {
        id
        reportType
        url
      }
    }
  }
`;

function parseCsvReports(items) {
  return items.map((item) => ({
    teamId: item.teamId,
    reports: item.reports.map((report) => ({
      id: report.id,
      reportType: report.reportType,
      url: report.url,
    })),
  }));
}

function getCsvReports(variables) {
  return apollo.client
    .query({
      query,
      variables,
      fetchPolicy: 'network-only',
    })
    .then((res) => parseCsvReports(res.data.getLatestCsvReports));
}

export default getCsvReports;
